import React from 'react';
import { Settings } from 'lucide-react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-[var(--row)] dark:bg-gray-950 flex items-center justify-center px-6">
      <div data-testid="maintenance-page" className="text-center max-w-md">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-6">
          <Settings size={28} className="text-amber-600 dark:text-amber-400 animate-spin" style={{ animationDuration: '4s' }} />
        </div>
        <h1 className="page-title mb-3">Under Maintenance</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed mb-6">
          We're performing a system upgrade. The platform will be back shortly.
          <br />Thank you for your patience.
        </p>
        <div className="flex items-center justify-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" style={{ animationDelay: '0.3s' }} />
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" style={{ animationDelay: '0.6s' }} />
        </div>
      </div>
    </div>
  );
}
